import * as React from 'react';
import styled from 'styled-components';

const TimerComponent = ( props:any) => (
    <div className={ props.className }>
        <div className={ 'timer' }>{ props.children }</div>
        <div className={ 'name' }>{ props.name }</div>
        <div className={ 'end' }>{props.endTime}</div>
    </div>
);

export default styled(TimerComponent)`
    display: flex;

    flex-grow: 1;
    flex-direction: column;
    justify-content: center;

    color: white;

    div.timer {
        font-size: 10vw;
    }

    div.name {
      font-size: 4vw;
    }
    
    div.end {
        font-size: 3vw;
    }
`;



// WEBPACK FOOTER //
// ./src/components/TimerComponent.tsx